import { Link, useParams } from '@remix-run/react';
import { useAtomValue, useSetAtom } from 'jotai';
import { $CategoryList } from 'shared/atoms/common/category';
import { FC, useCallback } from 'react';
import { ClickPosition } from '~/utils/click-position';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { $NavDrawerOpen } from '~/models/nav-drawer';
import { CategoryIDNameMap } from 'shared/models';

import './style.scss';

export const DrawerCategoryListPlaceholder: FC = () => {
  // TODO empty category placeholder
  return <div />;
};

export const DrawerCategoryList: FC = () => {
  const setOpen = useSetAtom($NavDrawerOpen);
  const categories = useAtomValue($CategoryList);
  console.log(categories);
  const { region } = useAtomValue($Locale);

  const handleClick = useCallback(() => {
    window.Tea('wap_click', {
      current_position: ClickPosition.side_bar_category,
    });
    setOpen(false);
  }, []);

  return (
    <ul className="content">
      {categories.map((category) =>
        CategoryIDNameMap[category.category] ? (
          <li key={category.category}>
            <Link onClick={handleClick} to={`/feed/${CategoryIDNameMap[category.category]}?region=${region}`}>
              {category.name}
            </Link>
          </li>
        ) : null,
      )}
    </ul>
  );
};
